module.exports = __webpack_public_path__ + "media/images/logo_white-058231d431e686020b85fab73c714944.svg";